import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	statusContainer: {
		display: "flex",
		alignItems: "center",
		flexWrap: "nowrap"
	},
	waitingStatusText: {
		wordBreak: "break-word",
		whiteSpace: "break-spaces",
		color: colors.purple[700],
		fontSize: "14px"
	},
	successStatusText: {
		wordBreak: "break-word",
		whiteSpace: "break-spaces",
		color: colors.green[700],
		fontSize: "14px"
	},
	errorStatusText: {
		wordBreak: "break-word",
		whiteSpace: "break-spaces",
		color: colors.red[400],
		fontSize: "14px"
	},
	waitingStatusIcon: {
		color: colors.purple[700],
		fontSize: "18px"
	},
	successStatusIcon: {
		color: colors.green[700],
		fontSize: "18px"
	},
	errorStatusIcon: {
		color: colors.red[400],
		fontSize: "18px"
	},
	/**
	 * Default ProgressBar class uses color.pallete.primary as a color
	 * Because of that, we dont need backgroundColor property here
	 */
	waitingProgressBar: {
		borderRadius: "8px",
		width: "100%"
	},
	successProgressBar: {
		borderRadius: "8px",
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600]),
		"& .MuiLinearProgress-bar": {
			...ColorUtil.getBackgroundAndContrastColor(colors.green[600])
		},
		width: "100%"
	}
})

export default useStyles
